import React, { useState } from "react";
import { Outlet } from 'react-router-dom';
interface ContactSupportPageProps {}

const ContactSupportPage: React.FC<ContactSupportPageProps> = () => {

  return (
       <><Outlet /></>
  );
};

export default ContactSupportPage;

